import { connectRouter, routerMiddleware } from 'connected-react-router';
// tslint:disable-next-line:no-implicit-dependencies
import * as history from 'history';
import { localizeReducer } from 'react-localize-redux';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
// tslint:disable-next-line:no-submodule-imports
import { all, fork } from 'redux-saga/effects';

import alertReducer from './alerts/reducer';
import applicationsReducer from './applications/reducer';
import authReducer from './auth/reducer';
import databaseReducer from './database/reducer';
import groupsReducer from './groups/reducer';
import navigationReducer from './navigation/reducer';
import serversReducer from './servers/reducer';
import tablesReducer from './tables/reducer';
import usersReducer from './users/reducer';
import workspacesReducer from './workspaces/reducer';

import alertSagas from './alerts/sagas';
import applicationsSagas from './applications/sagas';
import authSagas, { checkLogin } from './auth/sagas';
import databaseSagas from './database/sagas';
import groupsSagas from './groups/sagas';
import serversSagas from './servers/sagas';
import usersSagas from './users/sagas';
import workspacesSagas from './workspaces/sagas';

// Import all watching sagas
const watchSagas = [...alertSagas, ...authSagas, ...usersSagas,
...applicationsSagas, ...groupsSagas, ...workspacesSagas, ...serversSagas,
...databaseSagas];

export const browserHistory = history.createBrowserHistory({ basename: process.env.PUBLIC_URL });

// Set up root reducer
const reducers = {
    alerts: alertReducer,
    applications: applicationsReducer,
    auth: authReducer,
    database: databaseReducer,
    groups: groupsReducer,
    localize: localizeReducer,
    navigation: navigationReducer,
    router: connectRouter(browserHistory),
    servers: serversReducer,
    tables: tablesReducer,
    users: usersReducer,
    workspaces: workspacesReducer,
};

const rootReducer = combineReducers(reducers);

export type RootState = {
    [P in keyof typeof reducers]: ReturnType<typeof reducers[P]>;
};

function* rootSaga() {
    // initialize data
    yield fork(checkLogin);

    yield all(watchSagas.map((saga) => saga()));
}

// Create store
const sagaMiddleware = createSagaMiddleware();
const store = createStore(
    rootReducer, process.env.NODE_ENV === 'development' ?
    composeWithDevTools(applyMiddleware(routerMiddleware(browserHistory), sagaMiddleware)) :
    applyMiddleware(routerMiddleware(browserHistory), sagaMiddleware)
);

sagaMiddleware.run(rootSaga);

export default store;
